/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/order */

// Polyfill support for IE and legacy browsers
import 'custom-event-polyfill';
import 'core-js/es6';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { Provider } from 'react-redux';
import { VZThemeProvider } from '@vzrf/react-theme';
import './ImportComponents';
import { BrowserRouter } from 'react-router-dom';

import { ModelManager, Constants } from '@adobe/cq-spa-page-model-manager';
// VZRF Styles
// import './assets/css/vzrf.css';

// Typography / icons
import './assets/fonts/verizon-fonts/fonts.css';
import './assets/fonts/verizon-icons/fonts.css';
import './assets/css/layout.scss';

// Tooltip
import 'rc-tooltip/assets/bootstrap.css';

// PrimeReact, PrimeIcons, and VZPrime theme
// import 'primeicons/primeicons.css';
// import 'primereact/resources/primereact.min.css';
import '@vzprime/react/resources/utils/util-pixelSpacingAndText.css';
import '@vzprime/react/resources/themes/verizon-react.css';
import './assets/css/vzprime-extend.css';

import { VDSManager } from '@vds/utilities';
import { store } from './configureStore';
import history from './utils/history';
import ScrollToTop from './utils/RouteHelper';
// import NotificationBar from './components/common/NotificationBar';

import PageHeader from './components/common/PageHeader';
import PageFooter from './components/common/PageFooterRedesign';
import {
  isMoversFlow,
  isEUPFlow,
  TechFlow,
  eagleCPCFlow,
  whwTech,
  isDTDFlow,
  isRetailFlow,
  isCPCCheckAvailabilityFlow,
  isComboFlow,
} from './components/common/Helpers';

function render(pageModel, useHydrate) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter history={history}>
        {/* <NotificationBar page={history} section="page-header" /> */}
        <ScrollToTop>
          <VZThemeProvider>
            <>
              <VDSManager />
              <PageHeader
                history={history}
                taxFeeText={pageModel.taxFeeText}
                acpBannerContent={pageModel.acpBannerContent}
                acpBannerSpanishContent={pageModel.acpBannerSpanishContent}
                acpBannerFlag={pageModel.acpBannerFlag}
                withAutoPayPreview={pageModel.withAutoPayPreview}
                withAutoPayTooltipDesc={pageModel.withAutoPayTooltipDesc}
              />
              <App
                history={history}
                cqChildren={pageModel[Constants.CHILDREN_PROP]}
                cqItems={pageModel[Constants.ITEMS_PROP]}
                cqItemsOrder={pageModel[Constants.ITEMS_ORDER_PROP]}
                cqPath={pageModel[Constants.PATH_PROP]}
                locationPathname={window.location.pathname}
                apiServer={pageModel.apiServer}
                isProd={pageModel.isProd}
                isNBSSelf={pageModel.isNBSSelf}
                acpTagging={pageModel.acpTagging}
                isWHWISPU={pageModel.isWHWISPU}
                localOfferFlag={pageModel.localOfferFlag}
                excludeIndirect={pageModel.excludeIndirect}
                issetupEdit={pageModel.issetupEdit}
                isNBSProfessional={pageModel.isNBSProfessional}
                enableVideoCall={pageModel.enableVideoCall}
                integratedCartContactInfo={pageModel.integratedCartContactInfo}
                iscontactButtonEnabled={pageModel.iscontactButtonEnabled}
                getCheckOutDetails={pageModel.getCheckOutDetails}
                disableMdnCount={pageModel.disableMdnCount}
                isGnavEnabled={pageModel.isGnavEnabled}
                isSkipMtnApi={pageModel.isSkipMtnApi}
                sessionTimeoutTime={pageModel.sessionTimeoutTime}
                sessionTimeoutWarningTime={pageModel.sessionTimeoutWarningTime}
                registrationTimeoutNonProd={pageModel.registrationTimeoutNonProd}
                registrationTimeoutProd={pageModel.registrationTimeoutProd}
                asyncRequestWatcher={pageModel.asyncRequestWatcher}
                pdcFlag={pageModel.pdcFlag}
                fwaModalFlag={pageModel.fwaModalFlag}
                modalFwaTitle={pageModel.modalFwaTitle}
                fwaModalDesktopTimeout={pageModel.fwaModalDesktopTimeout}
                fwaModalMobileTimeout={pageModel.fwaModalMobileTimeout}
                fwaModalMobileImgUrl={pageModel.fwaModalMobileImgUrl}
                fwaModalDesktopImgUrl={pageModel.fwaModalDesktopImgUrl}
                invalidCaseStatusCode={pageModel.invalidCaseStatusCode}
                msgwithLinkErrorCode={pageModel.msgwithLinkErrorCode}
                isValidateCartCall={pageModel.isValidateCartCall}
                miniCartApi={pageModel.miniCartApi}
                localStorage={pageModel.localStorage}
                isLoader={pageModel.isLoader}
                enableAPFuncComp={pageModel.enableAPFuncComp}
                lqEditAddress={pageModel.lqEditAddress}
                acpIntegrated={pageModel.acpIntegrated}
                vfIntegrated={pageModel.vfIntegrated}
                isBroadBandFacts={pageModel.isBroadBandFacts}
                nonVzConsent_dark={pageModel.nonVzConsent_dark}
                lteHomePlus={pageModel.lteHomePlus}
                lteHome={pageModel.lteHome}
                fiveGHomePlus={pageModel.fiveGHomePlus}
                fiveGHome={pageModel.fiveGHome}
                isUnitTypeAhead={pageModel.isUnitTypeAhead}
                isOnlyTypeAhead={pageModel.isOnlyTypeAhead}
                useTypeAheadSoeUrl={pageModel.useTypeAheadSoeUrl}
                reqCustAgreeRead={pageModel.reqCustAgreeRead}
                enablePegaProcessStep={pageModel.enablePegaProcessStep}
              />
              <PageFooter />
            </>
          </VZThemeProvider>
        </ScrollToTop>
      </BrowserRouter>
    </Provider>,
    document?.getElementById('page'),
  );
}
if (isMoversFlow()) {
  ModelManager.initialize({ path: 'content/vcg/movers' }).then(render);
} else if (isEUPFlow() === 'true') {
  ModelManager.initialize({ path: 'content/vcg/upgrade' }).then(render);
} else if (TechFlow() === 'true') {
  ModelManager.initialize({ path: 'content/vcg/tech' }).then(render);
} else if (eagleCPCFlow() === 'true') {
  ModelManager.initialize({ path: 'content/vcg/eaglecpc' }).then(render);
} else if (whwTech() === 'true') {
  ModelManager.initialize({ path: 'content/vcg/whwTech' }).then(render);
} else if (isDTDFlow() === 'true') {
  ModelManager.initialize({ path: 'content/vcg/dtd' }).then(render);
} else if (isRetailFlow()) {
  ModelManager.initialize({ path: 'content/vcg/retail' }).then(render);
} else if (isCPCCheckAvailabilityFlow()) {
  ModelManager.initialize({ path: 'content/vcg/cpcCheckAvailability' }).then(render);
} else {
  ModelManager.initialize({ path: 'content/vcg/home' }).then(render);
}
